import styled from "styled-components";
import { TimeFrame } from '@hud/portal-dtos/webapp-common.dto';
import useOverviewEntityTotals from '../../hooks/overview/useOverviewEntityTotals';
import EntityTotalCard from '@hud/web-components/DesignSystem/Components/DiscoveryPage/EntityTotalCard/EntityTotalCard';
import { useGlobalQueryString } from '../../hooks/useGlobalFilter';

type EntityTotalsRendererProps = {
  environmentName: string;
  timeFrame: TimeFrame;
  services?: number[];
}

export default function EntityTotalsRenderer({
     environmentName,
     timeFrame,
     services }: EntityTotalsRendererProps ) {
  const { data: entityTotalsData, isLoading } = useOverviewEntityTotals({
    environmentName,
    timeFrame,
    serviceIds: services,
  });
  const globalQueryString = useGlobalQueryString();
  const filters = `${globalQueryString}&services=${services?.join(',')}`;

  return <Container>
    <li>
      <EntityTotalCard
        entityType={"endpoint"}
        calledFigure={entityTotalsData?.endpoints.calledFigure}
        mappedFigure={entityTotalsData?.endpoints.mappedFigure}
        url={`/explore/endpoints?${filters}`}
        isLoading={isLoading}
      />
    </li>
    <li>
      <EntityTotalCard
        entityType={"queue"}
        calledFigure={entityTotalsData?.queues.calledFigure}
        mappedFigure={entityTotalsData?.queues.mappedFigure}
        url={`/explore/messageQueues?${filters}`}
        isLoading={isLoading}
      />
    </li>
    <li>
      <EntityTotalCard
        entityType={"function"}
        calledFigure={entityTotalsData?.functions.calledFigure}
        mappedFigure={entityTotalsData?.functions.mappedFigure}
        url={`/explore/functions?${filters}`}
        isLoading={isLoading}
      />
    </li>
  </Container>
}

const Container = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  gap: 1rem;

  li {
    flex: 1;
  }
`
